export default "__VITE_PUBLIC_ASSET__db6e6823__"